import React from "react";

export const ErrorComponent = ({error}) => 
  <p>An Error Occurred: {error}</p>